import { defineComponent as R, mergeModels as y, useModel as D, useTemplateRef as v, computed as P, reactive as j, ref as N, inject as T, provide as U, createElementBlock as _, openBlock as b, mergeProps as O, unref as l, createCommentVNode as V, createVNode as c, Fragment as x, withCtx as M, renderSlot as E } from "vue";
import m from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Menu/menu.js";
import { isDefined as H } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { provideChildrenTracker as q } from "../../use/children-tracker.js";
import z from "../../helpers/AutoWrap.vue2.js";
import G from "../Divider.vue2.js";
import J from "./MenuContent.vue2.js";
import g from "./MenuGroup.vue2.js";
import k from "./MenuList.vue2.js";
import Q from "./MenuItem.vue2.js";
import W from "./MenuInput.vue2.js";
import X from "../TextInput.vue2.js";
import Y from "../TextInputGroup/TextInputGroup.vue2.js";
import Z from "../SearchInput/SearchInput.vue2.js";
import { useOUIAProps as ee } from "../../helpers/ouia.js";
const oe = Symbol("MenuItemsKey"), $ = Symbol("MenuInjectionKey"), _e = /* @__PURE__ */ R({
  name: "PfMenu",
  __name: "Menu",
  props: /* @__PURE__ */ y({
    containsFlyout: { type: Boolean },
    navFlyout: { type: Boolean },
    menuDrilledIn: { type: Boolean },
    activeItemId: {},
    rootMenu: { type: Boolean },
    plain: { type: Boolean },
    scrollable: { type: Boolean },
    onActionClick: {},
    favoritesLabel: { default: "Favorites" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    selected: { default: null },
    selectedModifiers: {}
  }),
  emits: /* @__PURE__ */ y(["search-input-change", "select"], ["update:selected"]),
  setup(u, { expose: h, emit: A }) {
    const r = u, I = ee({ id: r.ouiaId, safe: r.ouiaSafe }), t = D(u, "selected"), B = A, w = v("elRef"), C = v("favoriteListRef"), a = q(oe), F = P(() => a.reduce((e, o) => e + (o.favorited ? 1 : 0), 0)), K = j({
      // ouiaStateId: getDefaultOUIAId(Menu.displayName),
      transitionMoveTarget: null,
      disableHover: !1
    }), S = N(null), L = T($, void 0);
    U($, {
      parentMenu: L,
      favoriteList: C,
      selected: t,
      // drilldownItemPath: $props.drilldownItemPath,
      activeItemId: r.activeItemId,
      state: K,
      flyout: S,
      onActionClick: r.onActionClick,
      onSelect(e, o) {
        if (B("select", e, o), !!H(o))
          if (Array.isArray(t.value)) {
            const n = t.value.indexOf(o);
            if (n >= 0) {
              const s = [...t.value];
              s.splice(n, 1), t.value = s;
            } else
              t.value = [...t.value, o];
          } else
            t.value === o ? t.value = null : t.value = o;
      }
      // onDrillIn: $props.onDrillIn,
      // onDrillOut: $props.onDrillOut,
    });
    function d(e) {
      if (e.key !== "ArrowDown" && e.key !== "ArrowUp")
        return;
      const o = a.filter((i) => !i.disabled);
      if (!o.length)
        return;
      let n = o.findIndex((i) => i.focused);
      n < 0 && (n = o.findIndex((i) => {
        var p;
        return e.target instanceof Node && ((p = i.element) == null ? void 0 : p.contains(e.target));
      }));
      for (const i of a)
        i.focused = !1;
      const s = ((n < 0 && e.key === "ArrowUp" ? o.length : n + o.length) + (e.key === "ArrowDown" ? 1 : -1)) % o.length, f = o[s];
      f && (f == null || f.focus());
    }
    return h({
      el: w,
      items: a,
      handleKeyboard: d
    }), (e, o) => (b(), _("div", O(l(I), {
      ref: "elRef",
      class: [l(m).menu, {
        [l(m).modifiers.plain]: e.plain,
        [l(m).modifiers.scrollable]: e.scrollable,
        [l(m).modifiers.flyout]: e.containsFlyout,
        "pf-m-nav": e.navFlyout
        // [styles.modifiers.drilldown]: containsDrilldown,
        // [styles.modifiers.drilledIn]: effectiveMenuDrilledIn,
      }],
      onKeydown: d
    }), [
      F.value ? (b(), _(x, { key: 0 }, [
        c(g, { label: e.favoritesLabel }, {
          default: M(() => [
            c(k, { ref: "favoriteListRef" }, null, 512)
          ]),
          _: 1
        }, 8, ["label"]),
        c(G)
      ], 64)) : V("", !0),
      c(z, {
        options: [
          { component: W, include: [X, Y, Z] },
          { component: J, include: [g, k, Q] }
        ]
      }, {
        default: M(() => [
          E(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["options"])
    ], 16));
  }
});
export {
  $ as MenuInjectionKey,
  oe as MenuItemsKey,
  _e as default
};
